import MobileDetect from 'mobile-detect';

export const extractIdFromNode = (node) => Buffer.from(node, 'base64').toString('ascii').split(':')[1];

export const noop = () => {};

/**
 * Util JSON parse wrapper, used for configuration lists
 */
export function parseJsonOrNull (data) {
    try {
        return JSON.parse(data);
    } catch (error) {
        return null;
    }
}

const detect = new MobileDetect(window.navigator.userAgent);

/**
 * Information about the current device
 */
export const device = {
    userAgent: detect.ua,
    phone: detect.phone(),
    tablet: detect.tablet(),
    os: detect.os(),
    get isMobile () {
        return !!this.phone;
    },
    get isDesktop () {
        return !this.phone && !this.tablet;
    },
};

export const isFromRouter = !!window.teester;

/**
 * Ensure a given URL ends with a trailing slash
 */
export const formatUrl = (str) => str + (str.endsWith('/') ? '' : '/');

/**
 * Concatenates an array of elements into one string removing nulls or undefiled.
 * @param array
 * @param separator
 */
export const getTextFromArray = (array, separator = ' ') => array.filter(Boolean).join(separator);

export const regexBySocialNetwork = {
    INSTAGRAM: /^(?:http|https):\/\/(?:www.)?(?:instagram.com|instagr.am|instagr.com)\/(\w+)/,
    TWITTER: /^https:\/\/(?:www.)?twitter.com\/(?![a-zA-Z0-9_]+\/)([a-zA-Z0-9_]+)/,
    YOUTUBE: /^(http|https):\/\/(?:www.)?youtube\.com\/@[a-zA-Z0-9_-]{1,}/,
    SNAPCHAT: /^https:\/\/(?:www\.)?snapchat\.com\/add\/[A-z0-9._-]+/,
    FACEBOOK: /^(http|https):\/\/(?:www.)?facebook.com\/[A-z0-9._-]+/,
};

// On as product platform we allow the user to have multiple projects at the same time on different products
// even if those projects are still pending, so we need to check if a project matching the product_id already exist.
// But on the other platform it's not possible to have multiple pending projects at the same time
export const getProjectFromState = (state, productId, isProductPlatform) => {
    let project = null;
    if (isProductPlatform) {
        // We first try to find a project using the productId
        project = state.projects.find((p) => p.productId === extractIdFromNode(productId));
        if (!project) {
            // It's possible that a project exist for this product without having a productId because the technical link between the project
            // and product was only implemented at the beginning of 2023
            // We use the productReference in the uploadInformation (it's a data set in the state by the product platform) to try and find
            // a project with that productReference (the product reference can be updated in the project so it's clearly not a stable link)
            const { productReference } = state.uploadInformation;
            project = state.projects.find(({ productReferences }) => productReferences.includes(productReference));
        }

        // If a project is found by product or by reference but is not pending or pending_rushes we need to create a new project
        if (project && !['PENDING', 'PENDING_RUSHES'].includes(project.status)) {
            project = null;
        }
    } else {
        project = state.projects.find(({ status }) => ['PENDING', 'PENDING_RUSHES'].includes(status));
    }
    return project;
};

export const buildSmartUploaderUrl = ({
    smartUploaderConfig, captureFrontUrl, product, order,
}) => {
    if (!smartUploaderConfig) {
        return null;
    }

    const params = {
        meta: {
            ...(product ? { PRODUCT_NAME: product.name } : {}),
            ...(product ? { PRODUCT_URL: product.pageUrl } : {}),
            ...(product ? { PRODUCT_ID_INTERNAL: extractIdFromNode(product.id) } : {}),
            ...(order ? { ORDER_ID: extractIdFromNode(order.id) } : {}),
            CUSTOM_THUMBNAILS_1: smartUploaderConfig.thumbnailText1,
            CUSTOM_THUMBNAILS_2: smartUploaderConfig.thumbnailText2,
        },
    };
    return `${captureFrontUrl}/?solutionId=${smartUploaderConfig.solution.id}&params=${encodeURIComponent(JSON.stringify(params))}`;
};

export const getFileNameFromUploadUrl = (url) => {
    const parts = decodeURIComponent(url).split('/');
    return parts[parts.length - 1];
};

export const parseGraphqlError = (err, config) => {
    if (err.graphQLErrors && err.graphQLErrors.length) {
        const details = err.graphQLErrors[0].extensions;

        if (details.code === 'INPUTS_UPLOAD_FAILED') {
            return `${config[`ERROR_${details.code}`] || err.message} ${details.notFoundFiles ? `(${details.notFoundFiles.map(getFileNameFromUploadUrl).join(', ')})` : ' '}`;
        }

        if (details.code === 'NO_INPUTS_PROVIDED') {
            return config[`ERROR_${details.code}`] || err.message;
        }

        return null;
    }
    return null;
};

